/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { countResponseSchema } from '../campaign-schema';

export const getRecentPostsCountPathSchema = z.object({
  campaignId: z.string(),
});

export const getRecentPostsCountOperationResponseSchema = countResponseSchema;

export type GetRecentPostsCountInput = {
  path: z.input<typeof getRecentPostsCountPathSchema>;
  signal?: AbortSignal;
};

export async function getRecentPostsCount({
  path,
  signal,
}: GetRecentPostsCountInput): Promise<
  z.infer<typeof getRecentPostsCountOperationResponseSchema>
> {
  const parsedPath = getRecentPostsCountPathSchema.parse(path);

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/recent_posts/count`,
    {
      signal,
    },
  );
  return getRecentPostsCountOperationResponseSchema.parse(
    await response.json(),
  );
}
